// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"8e1054be","217":"05d12df8","245":"8b1b2407","344":"04cf871f","625":"eca58610","647":"8ae3686c","682":"1e5135c4","759":"7391a3fc","802":"d69a4012","931":"4c3a003d","960":"fb364a67"}[chunkId] + ".chunk.js";
};